import { render, staticRenderFns } from "./shezhi.vue?vue&type=template&id=63d19518&scoped=true&"
import script from "./shezhi.vue?vue&type=script&lang=js&"
export * from "./shezhi.vue?vue&type=script&lang=js&"
import style0 from "./shezhi.vue?vue&type=style&index=0&id=63d19518&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d19518",
  null
  
)

export default component.exports